import React from "react";
import * as serviceWorker from "./serviceWorker";
// import history from "history";
// `require("history").createBrowserHistory` instead of`require("history/createBrowserHistory")`.
// import createBrowserHistory from require("history").createBrowserHistory;
import { Provider } from "mobx-react";
import { RouterStore, syncHistoryWithStore } from "mobx-react-router";
import { Router } from "react-router";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

const browserHistory = require("history").createBrowserHistory();
const routingStore = new RouterStore();

const stores = {
  // Key can be whatever you want
  routing: routingStore,
  // ...other stores
};

const history = syncHistoryWithStore(browserHistory, routingStore);

ReactDOM.render(
  <Provider {...stores}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
